import { TrackingHandler } from './TrackingHandler';
import { BrowserProvider } from './providers/BrowserProvider';
import { PageProvider } from './providers/PageProvider';
import { LocalStorageProvider } from './providers/LocalStorageProvider';
import { FallbackProvider } from './providers/FallbackProvider';
import { SessionStorageProvider } from './providers/SessionStorageProvider';
import { GtmListener } from './listeners/GtmListener';
import { LocalStorageListener } from './listeners/LocalStorageListener';
import { SessionStorageListener } from './listeners/SessionStorageListener';
import { LoggerListener } from './listeners/LoggerListener';
import { ServerSideGtmListener } from './listeners/ServerSideGtmListener';
import { PhoneTrackingListener } from './listeners/PhoneTrackingListener';
import { EgroupParameterProvider } from './providers/EgroupParameterProvider';
export const initTracking = () => {
    const trackingHandler = TrackingHandler.getInstance();
    window.trackingHandler = trackingHandler;
    trackingHandler.providers.push(new EgroupParameterProvider());
    trackingHandler.providers.push(new PageProvider());
    trackingHandler.providers.push(new BrowserProvider());
    trackingHandler.providers.push(new SessionStorageProvider());
    trackingHandler.providers.push(new LocalStorageProvider());
    trackingHandler.providers.push(new FallbackProvider());
    trackingHandler.listeners.push(new SessionStorageListener());
    trackingHandler.listeners.push(new LocalStorageListener());
    trackingHandler.listeners.push(new LoggerListener());
    trackingHandler.listeners.push(new GtmListener());
    trackingHandler.listeners.push(new ServerSideGtmListener());
    trackingHandler.listeners.push(new PhoneTrackingListener());
    trackingHandler.pageReady();
    window.addEventListener('ucEvent', (e) => {
        const ucEvent = e.detail;
        if (ucEvent.action === 'onInitialPageLoad' && ucEvent.type === 'implicit') {
            return;
        }
        trackingHandler.setConsent(ucEvent.ucCategory.essential, ucEvent.ucCategory.functional, ucEvent.ucCategory.marketing);
    });
};
